// Loads reCAPTCHA Enterprise only when a visitor starts on a form, instead of on
// every page view: the script costs ~400KB and ~0.5s of main-thread time.
// Resolves with grecaptcha.enterprise, or null when it is blocked or too slow.
let loading = null

export function loadRecaptcha(siteKey, timeoutMs = 8000) {
  if (!siteKey) return Promise.resolve(null)
  if (loading) return loading

  loading = new Promise((resolve) => {
    const done = () => {
      const enterprise = window.grecaptcha && window.grecaptcha.enterprise
      if (!enterprise) return resolve(null)
      enterprise.ready(() => resolve(enterprise))
    }
    if (window.grecaptcha && window.grecaptcha.enterprise) return done()

    const timer = setTimeout(() => resolve(null), timeoutMs)
    const script = document.createElement('script')
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${encodeURIComponent(siteKey)}`
    script.async = true
    script.onload = () => { clearTimeout(timer); done() }
    script.onerror = () => { clearTimeout(timer); loading = null; resolve(null) }
    document.head.appendChild(script)
  })
  return loading
}

// A fresh single-use token for this action, or "" when reCAPTCHA is unavailable.
export async function recaptchaToken(siteKey, action) {
  const enterprise = await loadRecaptcha(siteKey)
  if (!enterprise) return ''
  try {
    return await enterprise.execute(siteKey, { action })
  } catch {
    return ''
  }
}

// Start loading as soon as someone focuses or touches the form.
export function preloadRecaptchaOn(element, siteKey) {
  if (!element || !siteKey) return
  const start = () => loadRecaptcha(siteKey)
  element.addEventListener('focusin', start, { once: true })
  element.addEventListener('pointerdown', start, { once: true })
}
